import __var_0__ from '@stdlib/math/base/assert/is-nan';
import __var_1__ from '@stdlib/constants/math/float64-sqrt-half-pi';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isnan = __var_0__;
var SQRT_HALF_PI = __var_1__;


// MAIN //

/**
* Returns the expected value of a Rayleigh distribution.
*
* @param {NonNegativeNumber} sigma - scale parameter
* @returns {NonNegativeNumber} expected value
*
* @example
* var v = mean( 9.0 );
* // returns ~11.28
*
* @example
* var v = mean( 2.0 );
* // returns ~2.507
*
* @example
* var v = mean( -0.2 );
* // returns NaN
*
* @example
* var v = mean( NaN );
* // returns NaN
*/
function mean( sigma ) {
	if ( isnan( sigma ) || sigma < 0.0 ) {
		return NaN;
	}
	return sigma * SQRT_HALF_PI;
}


// EXPORTS //
export default mean;
